module.exports = __webpack_public_path__ + "static/media/banner1.9826ecb0.jpg";